// extracted by mini-css-extract-plugin
module.exports = {"container":"Login__container--1kMO06jJ9s8CYFNCDHz4gH","rcbcLogo":"Login__rcbc-logo--1KW81HtWNKEbHIrL40omw1","error":"Login__error--3ybsEjfMReXy-891caNUzt"};